import "./Banglore_cities.css";
const Chennai_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Mount Road</p>
            <p className="city">Chennai Central Railway Station</p>
            <p className="city">Ecr East Coast Road</p>
            <p className="city">T Nagar</p>
            <p className="city">Chennai International Airport</p>
            <p className="city">Nungambakkam</p>
            <p className="city">Anna Nagar</p>
            <p className="city">Porur</p>
            <p className="city">All of Chennai </p>
           
        </div>
    )
}
export {Chennai_cities}